import { useEffect } from "react"
import EpbPinStatusByNodalOfficer from "../../Officers/NodalOfficer/EpbPinStatusByNodalOfficer"
import { useLazyGetPhaseNodetailsQuery } from "../../../services/announceElection"
import { USERTYPE } from "../../../constants/constants"

function NodalOfficerDashboard() {
  const [phaseNo,datap] = useLazyGetPhaseNodetailsQuery()


  useEffect(()=>{
    phaseNo().then((res)=>{
      var data = []
  res?.data?.payload?.map((item)=>{
    data.push(item?.phaseNo)
  })
  let string = JSON.stringify(data)
  localStorage.setItem("phaseList",string)
    })
  },[])

  return (
    <>
     <EpbPinStatusByNodalOfficer />
    </>
  )
}

export default NodalOfficerDashboard
